import { useEffect } from 'react';
const codes = [
    'ArrowUp',
    'ArrowRight',
    'ArrowDown',
    'ArrowLeft',
    'Delete',
    'Backspace',
    'Escape',
    'Equal',
    'Minus',
    'Backslash',
    'Slash',
    'intlbackslash',
    'Comma',
    'Period',
    'Quote',
    'Backquote',
    'Semicolon',
    'BracketLeft',
    'BracketRight',
    'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12'
];
const reserved = [
    'meta+r',
    'meta+shift+r',
    'meta+comma',
    'meta+s',
    'meta+o',
    'meta+y',
    'meta+bracketleft',
    'meta+bracketleft',
    'meta+bracketright',
    'meta+arrowleft',
    'meta+arrowright'
];
function cmdFromKey(e, shortcuts) {
    let key = [
        e.altKey ? 'alt' : '',
        e.ctrlKey ? 'ctrl' : '',
        e.metaKey ? 'meta' : '',
        e.shiftKey ? 'shift' : '',
        (codes.find(code => code == e.code) ?? e.code?.replace('Key', '').replace('Digit', ''))?.toLowerCase()
    ].filter(key => !!key).join('+');
    return shortcuts.find(shortcut => shortcut.key == key);
}
export const useShortcuts = (shortcuts, on, deps = []) => {
    useEffect(() => {
        const onKey = (e) => {
            const binding = cmdFromKey(e, shortcuts);
            if (binding) {
                if (reserved.includes(binding.key)) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                on(binding.command, e);
            }
        };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, deps);
};
